import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { FileService } from 'src/app/service/file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-absence-assignment-update',
  templateUrl: './absence-assignment-update.component.html',
  styleUrls: ['./absence-assignment-update.component.scss']
})
export class AbsenceAssignmentUpdateComponent implements OnInit {

  showLoader: boolean = false;
  updating: boolean = false;
  students: any = [];
  absTypes:any;
  absenceFile:any;
  absenceFileName:any;
  oldAbsenceFileName:any;
  itemFileNameWithoutPath:any="";
  attachmentFileLink:any="";
  assID: any;

  updateAbsenceRequest = new FormGroup({
    student: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      Validators.required,
    ]),
    assignmentDes: new FormControl('', [
      // Validators.required,
    ]),
    assignmentDesFile: new FormControl('', [
      // Validators.required,
    ]),
    assignmentAns: new FormControl('', [
      // Validators.required,
    ]),
    assignmentAnsFile: new FormControl('', [
      // Validators.required,
    ]),
    // status: new FormControl('', [
    //   Validators.required,
    // ]),
  });

  constructor(private attendanceService:AttendanceService,private fileService: FileService,
    private toastrService: ToastrService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public translate: TranslateService) {
   }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.assID = params['assID'] || "";
        // console.log("teachID",this.typeID);

        if (this.assID != "" && this.assID > 0) {
         // this.getAbsType();
         this.updateAbsenceRequest.controls.student.setValue("Reda");
        this.updateAbsenceRequest.controls.remarks.setValue("remark");
        this.updateAbsenceRequest.controls.assignmentDes.setValue("Desc");
        this.attachmentFileLink = `${environment.API_URL_UTIL}/api/downloadFile/`;
        this.oldAbsenceFileName = "Desc";
        this.updateAbsenceRequest.controls.assignmentAns.setValue("Answer");
        this.attachmentFileLink = `${environment.API_URL_UTIL}/api/downloadFile/`;
        this.oldAbsenceFileName = "Desc";
        this.showLoader = false;
          
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/attendence/authorized-absence-request']);
        }
      });
  }

  getAbsType() {
    let orgId = this.globals.orgId;
    this.attendanceService.getAbscenceTypes(orgId)
      .subscribe(
        data => {
          this.absTypes = data;
          this.getStudentsByRole();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  getStudentsByRole() {
    let orgId = this.globals.orgId;
    let username = this.globals.currentUserInfo.username;
    let userId =0;
    let studentid=this.globals.currentUserInfo.studentid;
    let teacherid=this.globals.currentUserInfo.teacherid;
    if(studentid!=null){
      userId=studentid;
    }else if(teacherid!=null){
      userId=teacherid;
    }else{
      userId =0;
    }
    this.attendanceService.getStudentsByUser(orgId,username,userId)
      .subscribe(
        data => {
          this.students = data;
          this.getAbsenceRequestById();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  getAbsenceRequestById(){
    this.attendanceService.getAbscenceRequestById(this.assID)
    .subscribe(
      data => {
        this.updateAbsenceRequest.controls.student.setValue(data.studentid);
        this.updateAbsenceRequest.controls.absenceType.setValue(data.atntypeid);
        this.updateAbsenceRequest.controls.dateFrom.setValue(data.dateFrom);
        this.updateAbsenceRequest.controls.dateTo.setValue(data.dateTo);
        this.updateAbsenceRequest.controls.remarks.setValue(data.remarks);
        this.attachmentFileLink = `${environment.API_URL_UTIL}/api/downloadFile/${data.attachmentFilename}`;
        this.oldAbsenceFileName = data.attachmentFilename;
        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }

  updateAbsenceRequestChange() {
    // let classHours = this.updateAbsenceRequest.controls.classHours.value;
    // let clinicalHours = this.updateAbsenceRequest.controls.clinicalHours.value;
    // this.updateAbsenceRequest.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  updateAbsenceRequestSubmit() {
    
    if (this.updateAbsenceRequest.valid) {
      console.log("creating absence request");
      console.log(this.updateAbsenceRequest.value);
      this.updating=true;
      console.log(this.absenceFile);
      if(typeof this.absenceFile !== 'undefined'){
        this.handleUploadFiles();
      }else{
        this.absenceFileName = this.oldAbsenceFileName;
        this.updateAbscenceRequest();
      }
      
    } else {
      this.updateAbsenceRequest.markAllAsTouched();
      this.updateAbsenceRequest.markAsDirty();
    }
  }

  handleUploadFiles() {
    let formData = new FormData();

    let fname = this.absenceFile.name.split('.').slice(0, -1).join('.')
    let fext = this.absenceFile.name.split('.').pop()
    this.absenceFileName = fname + "_" + Date.now() + "." + fext
    formData.append('file', this.absenceFile, this.absenceFileName);

    console.log("file name : " + this.absenceFileName);


    this.fileService.uploadFile(formData).subscribe(
      data => {
        this.updateAbscenceRequest()
      },
      error => {
        this.updating = false
        this.toastr.warning(this.translate.instant("CAN_NOT_UPLOAD_FILES"));
      }
    );
  }

  
  changeFile(event: any) {
    let typesAccept = ['application/pdf'];
    // Max size 200 MEGA
    let maxSize = 209715200;
    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.absenceFile = event.target.files[0];
        return true;
      } else {
        this.updateAbsenceRequest.controls.attachment.reset();
        this.updateAbsenceRequest.controls.attachment.markAsDirty();
        this.updateAbsenceRequest.controls.attachment.markAsTouched();

        if (currentFile.size > maxSize) {
          this.toastr.error(this.translate.instant("MAX_FILE_SIZE_200_MB"))
        }
        return false;
      }
    } else {
      return false;
    }
  }

  updateAbscenceRequest() {
    let username = this.globals.currentUserInfo.username;
    let orgId = this.globals.orgId;
    let year = this.globals.currentUserInfo.yearid;
    let semester = this.globals.currentUserInfo.semesterid;
    let dateFrom=new Date(this.updateAbsenceRequest.controls.dateFrom.value);
    let dateTo=new Date(this.updateAbsenceRequest.controls.dateTo.value);
    console.log(dateFrom);
    console.log(dateTo);
    let timeInMilisec: number = dateTo.getTime() - dateFrom.getTime();
    let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
    console.log(timeInMilisec);
    console.log(daysBetweenDates);
    let userId = this.globals.currentUserInfo.userid;
    let fileName="";
    if(this.absenceFileName==null){
      fileName=this.itemFileNameWithoutPath;
    }else{
      fileName=this.absenceFileName;
    }
    this.attendanceService.updateAbscenceRequest(this.assID, username,orgId,year,semester,
      this.updateAbsenceRequest.controls.student.value,
      this.updateAbsenceRequest.controls.absenceType.value,
      this.updateAbsenceRequest.controls.dateFrom.value,
      this.updateAbsenceRequest.controls.dateTo.value,
      daysBetweenDates,
      this.updateAbsenceRequest.controls.remarks.value,
      "DRAFT",
      fileName,
      "YES"      
    )
      .subscribe(
        data => {
          this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
          this.router.navigate(['/attendence/authorized-absence-request']);
        },
        error => {
          this.updating = false
          this.toastr.warning(this.translate.instant('CAN_NOT_UPDATE'));
        }
      );
  }
}
